// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tutorial_ReportUsersResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Tutorial_ReportUserRow } from './Tutorial_ReportUserRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Tutorial_ReportUsersResponseDados = Tutorial_ReportUserRow[];

export type Tutorial_ReportUsersResponse = ApiResponse<Tutorial_ReportUsersResponseDados>;

registerResponseContract('Tutorial_ReportUsersResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      tutorial_progress_id:           { type: 'string',  required: true },
      tutorial_progress_user_id:      { type: 'string',  required: true },
      tutorial_progress_slug:         { type: 'string',  required: true },
      tutorial_progress_status:       { type: 'string',  required: true },
      tutorial_progress_step_reached: { type: 'string',  required: true },
      tutorial_progress_started_at:   { type: 'string',  required: true },
      tutorial_progress_completed_at: { type: 'string',  required: false },
      tutorial_progress_replay_count: { type: 'string',  required: true },
      user_name:                      { type: 'string',  required: true },
    },
  },
})
